/**
 * Styled Components - Created by cazarez on 07/02/18.
 */
import styled from 'styled-components'
import Dropdown from 'antd/lib/dropdown'
import { GRAY } from '../../theme/colors'

export const Container = styled.div`
  color: white;
  font-size: 12px;
  line-height: 16px;
  margin-bottom: 15px;
  font-weight: 200;

  @media (max-width: 698px) {
    margin-bottom: 24px;
    position: relative;
  }
`
export const Title = styled.div`
  height: 14px;
  color: white;
  font-size: 14px;
  font-weight: bold;
  line-height: 14px;
  margin-bottom: 15px;
`

export const AddressText = styled.div`
  font-weight: 400;
`

export const DropdownStyled = styled(Dropdown)`
  display: flex;
  align-items: center;
  border: 1px solid #686868;
  width: fit-content;
  padding: 4px 8px;
  border-radius: 3px;
  @media (max-width: 698px) {
    position: absolute;
    top: -10px;
    right: 0;
  }
`

export const Option = styled.div`
  display: flex;
  align-items: center;
`

export const MenuOption = styled.div`
  color: #5f6062;
  margin-left: 12px;
  font-size: 14px;
  line-height: 22px;
`

export const FlagIconButton = styled.img`
  max-width: 22px;
  border-radius: 3px;
  &:hover { 
    cursor: pointer;
  }
`

export const CurrencyDiv = styled.div`
  display: flex;
  align-items: center;
  &:hover {
    cursor: pointer;
  }
`

export const ContactLabel = styled.div`
  margin-bottom: 15px;
`

export const PhoneLabel = styled.a`
  color: #fff;
  text-decoration: underline;
  margin-bottom: 15px;
  font-size: 15px;
  display: inline-block;
  &:hover {
    color: #fff;
    text-decoration: underline;
  }
`

export const Subtitle = styled.div`
  font-size: 11.5px;
  color: ${GRAY};
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ContactInfo/styledComponents.tsx